<template>
    <div style="background:#f0f0f0" v-loading="isload">
        <Header/>
        <Nav :list="headerList"/>
        <div class="middle-content">
            <div class="header-title">{{status==='search' ? '成绩查询' : `${name}的成绩`}}</div>
            <div v-if="status!=='search'" class="result">
                <div style="margin-bottom: 20px;">姓名：{{name}}</div>
                <div v-for="(item, index) in resultList" :key="index" class="result-item" :class="{'has-divider': index !== resultList.length - 1}">
                    <div >
                        <div class="result-row">
                            <span class="label">考试：</span><span class="value">{{item.name}}</span>
                        </div>
                        <div class="result-row">
                            <span class="label">科目：</span><span class="value">{{item.subject}}</span>
                        </div>
                        <div class="result-row">
                            <span class="label">时间：</span><span class="value">{{item.start_time}} - {{item.end_time}}</span>
                        </div>
                        <div class="result-row">
                            <span class="label">成绩：</span><span class="value" :class="{'pass-text': item.is_pass === '合格'}">{{item.is_pass}}</span>
                        </div>
                    </div>
                    
                </div>
                <div class="btn result-btn" @click="status='search'">返回
                </div>
            </div>
            <div v-if="status==='search'" class="form-body">
                <div class="form-group">
                    <label class="control-label">考试级别</label>
                    <select v-model="level" class="input-large select-large">
                        <option value ="0">初级国际财务管理师</option>
                        <option value ="1">助理级国际财务管理师</option>
                        <option value ="2">中级国际财务管理师</option>
                        <option value ="3">高级国际财务管理师</option>
                        <!-- <option value ="4">继续教育</option> -->
                    </select>
                </div>
                <div class="form-group">
                    <label class="control-label">考生姓名</label>
                    <input v-model="name" class="input-large" type="text" autocomplete="off" >
                </div>
                <div class="form-group">
                    <label class="control-label">身份证号</label>
                    <input v-model="cardId" class="input-large" type="text" autocomplete="off">
                </div>
                
                <div class="btn" @click="next">提交
                </div>
            </div>
        </div>
        <Footer/>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    computed: mapState([
    ]),
    components:{
    },
    data() {
        return {
            headerList:[
                {name:'首页', href:'/'},
                {name:'成绩查询', href:'/'},
            ],
            status:'search',
            level: '0',
            name:'',
            cardId:'',
            resultList: [],
            isload: false,
        }
    },
    mounted(){
    },
    methods: {
        async next(){
            if(this.name === ''){
                this.$toast('请输入考生姓名');
                return false;
            }
            if(this.cardId === ''){
                this.$toast('请输入考生身份证号');
                return false;
            }
            try {
                this.isload = true;
                const res = await this.$http.post('/api/exam/examination',{username:this.name,idNumber:this.cardId, grade: this.level});
                this.isload = false;
                if (res && res.list) {
                    this.resultList = res.list;
                } else {
                    this.resultList = [];
                }
                this.status = 'result';
            } catch (error) {
                this.isload = false;
                this.$toast(error.message||'请求失败');
            }
        }
    },
}
</script>
<style lang="scss" scoped>
.middle-content{
    width: 1120px;
    margin: 20px auto 22px auto;
    background: #fff;
    box-sizing: border-box;
    padding: 30px 0 47px 0;
}
.header-title{
    font-family: PingFangSC-Semibold;
    font-size: 22px;
    color: #235483;
    letter-spacing: 0.62px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 25px;
}
.form-body{
    width: 520px;
    margin: 0 auto;
}
.result{
    width: 520px;
    margin: 0 auto;
    font-size: 16px;
    color: #333333;
    letter-spacing: 0.45px;
    font-weight: 400;
}
.btn{
    padding: 9px 24px;
    display: inline-block;
    margin-left: 102px;
    margin-top: 42px;
    cursor: pointer;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 0.45px;
    font-weight: 600;
    font-family: PingFangSC-Semibold;
    background: #A4204F;
}
.result-btn{
    margin-left: 0;
    margin-top: 20px;
    background: #FFFFFF;
    border: 1px solid #979797;
    color: #333333;
}
.result-item {
    padding-bottom: 20px;
    margin-bottom: 20px;
}
.has-divider {
    border-bottom: 1px dashed #e0e0e0;
}
.result-row {
    margin-bottom: 15px;
    display: flex;
    align-items: flex-start;
}
.result-row:last-child {
    margin-bottom: 0;
}
.result-row .label {
    color: #666;
    width: 50px;
    flex-shrink: 0;
}
.result-row .value {
    color: #333;
    font-weight: 500;
}
.pass-text {
    color: #67C23A !important;
    font-weight: bold !important;
}
.select-large {
    width: 216px !important;
    height: 43px !important;
    padding-left: 10px !important;
    box-sizing: border-box;
    border-radius: 4px;
    border: 1px solid #cacaca;
    color: #333;
    font-size: 14px;
    background-color: #fff;
    cursor: pointer;
    outline: none;
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    background: url("data:image/svg+xml;utf8,<svg viewBox='0 0 140 140' width='14' height='14' xmlns='http://www.w3.org/2000/svg'><g><path d='m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z' fill='%23666666'/></g></svg>") no-repeat right 10px center;
    background-size: 14px;
}
.select-large:focus {
    border-color: #409EFF;
}
</style>
